import { Map, List } from 'immutable';

import { ApiResponseHelper } from 'omni-common-ui';

import {
  FETCH_STUDENT_TASK_RESULTS_REQUEST,
  FETCH_STUDENT_TASK_RESULTS_SUCCESS,
  FETCH_STUDENT_TASK_RESULTS_FAILURE,
  FETCH_STUDENT_TASK_LIST_REQUEST,
  FETCH_STUDENT_TASK_LIST_SUCCESS,
  FETCH_STUDENT_TASK_LIST_FAILURE,
} from './actions';
import StudentTasks from './model';
import StudentTaskResult from './StudentTaskResult';

const initialState = new Map({
  taskResults: new Map({}),
  taskList: new Map({}),
});

export default function studentTasksReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STUDENT_TASK_RESULTS_REQUEST:
      return state.setIn(
        ['taskResults', action.groupId],
        ApiResponseHelper.create({ loading: true })
      );
    case FETCH_STUDENT_TASK_RESULTS_SUCCESS:
      return state.setIn(
        ['taskResults', action.groupId],
        ApiResponseHelper.create(setStudentTasks(state, action.payload))
      );
    case FETCH_STUDENT_TASK_RESULTS_FAILURE:
      return state.setIn(
        ['taskResults', action.groupId],
        ApiResponseHelper.create(action.error)
      );
    case FETCH_STUDENT_TASK_LIST_REQUEST:
      return state.setIn(
        ['taskList', action.sessionId],
        ApiResponseHelper.create({ loading: true })
      );
    case FETCH_STUDENT_TASK_LIST_SUCCESS:
      return state.setIn(
        ['taskList', action.sessionId],
        ApiResponseHelper.create({ data: action.payload.data || action.payload })
      );
    case FETCH_STUDENT_TASK_LIST_FAILURE:
      return state.setIn(
        ['taskList', action.sessionId],
        ApiResponseHelper.create(action.error)
      );
    default:
      return state;
  }
}

function setStudentTasks(state, payload) {
  return new List(payload.map((tasksBySession) => {
    const studentTaskResults = new List(
      tasksBySession.studentTaskResults.map((taskByStudent) =>
        StudentTaskResult
          .create(taskByStudent)
          .set('sessionId', `${tasksBySession.sessionId}`)
      ));
    return StudentTasks
      .create(tasksBySession)
      .set('studentTaskResults', studentTaskResults);
  }));
}



// WEBPACK FOOTER //
// ./data/StudentTasks/reducer.js